

















import MHeader from "@/components/utility/mmmint/MHeader.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { Component, Vue } from "vue-property-decorator";
import PartnerReportCreateForm, {
  PartnerReportCreateFormSubmit
} from "@/components/partner/PartnerReportCreateForm.vue";
import TemplateDialog from "@/components/template/TemplateDialog.vue";
import { PartnerModule } from "@/store/modules/partner";

@Component({
  components: {
    TheLayoutPortal,
    MHeader,
    PartnerReportCreateForm,
    TemplateDialog
  }
})
export default class PartnerReportInitialize extends Vue {
  get partnerId() {
    return this.$route.params.partnerId;
  }

  get partner() {
    return PartnerModule.partner;
  }

  breadCrumbs: IBreadcrumb[] = [
    {
      text: "Schadenmeldungen",
      exact: true,
      disabled: false,
      to: {
        name: "PartnerReports",
        params: {
          partnerId: this.partnerId
        }
      }
    },
    {
      text: "Neu",
      exact: true,
      disabled: true,
      to: {
        name: "PartnerReportInitialize",
        params: {
          partnerId: this.partnerId
        }
      }
    }
  ];

  submit(submit: PartnerReportCreateFormSubmit) {
    this.$log.debug(submit);

    this.$router.push({
      name: "PartnerReportsDetailView",
      params: {
        partnerId: submit.report.partnerId,
        reportId: submit.report.id
      }
    });
  }
}
